import { Badge } from '@mantine/core';

import LogoImage from '../../assets/images/e-origin_logo.svg';
import classes from './Logo.module.css';

export const Logo = ({ badge, badgeColor, ...props }: { badge?: string; badgeColor: string; 'data-pw'?: string }) => {
  return (
    <div className={classes.logo}>
      <img src={LogoImage} alt="" data-pw={props['data-pw']} />
      {badge && (
        <Badge
          className={classes.badge}
          styles={{
            root: {
              backgroundColor: badgeColor,
            },
          }}
        >
          {badge}
        </Badge>
      )}
    </div>
  );
};
